import * as styles from './Divider.module.css'

function Divider() {
  return <span className={styles.Divider}>/</span>
}

export default Divider
